import React from 'react';
import Grid from '@material-ui/core/Grid';

function GlobalTotal(props) {
  return (
    <Grid item xs={12} style={props.style}>
      全體誦經累計次數： { props.total }
    </Grid>
  )
}

export default GlobalTotal;